import BigNumber from 'bignumber.js'

function formatWithUnderscores(value: BigNumber): string {
  if (!value.isFinite()) {
    return 'infinity'
  }

  return value.toFormat({ decimalSeparator: '.', groupSeparator: '_', groupSize: 3 })
}

const numberFormatterCompact = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  compactDisplay: 'short',
  maximumFractionDigits: 2,
})

function formatCompact(value: BigNumber): string {
  return numberFormatterCompact.format(value.toNumber())
}

export const numberFormatter = {
  withUnderscores: formatWithUnderscores,
  compact: formatCompact,
} as const
